// @flow
// phase 1 からコピーした

// /**
//  * sendRAT
//  * https://confluence.rakuten-it.com/confluence/display/COED/01-01.+Tracking+information+-+Campaign+In-Page+Survey
//  */
// import {
//   TOAST_STATE_ASK,
//   TOAST_STATE_NPS,
//   TOAST_STATE_FORM,
//   TOAST_STATE_FORM_AGREE,
//   TOAST_STATE_FORM_DISAGREE,
//   TOAST_STATE_COMPLETED,
//   TOAST_STATE_DECLINED,
// } from '../define';

export const RAT_ACCOUNT_ID_FOR_REX = '1253';

export const SCREEN = {
  PERMISSION: 'permission',
  NPS: 'nps',
  INQUIRY: 'inquiry',
  THANKYOU: 'thankyou',
};

export const ACTION = {
  APPEAR: 'appear',
  CLOSE: 'close',
  AGREE: 'agree',
  DISAGREE: 'disagree',
  ANSWER: 'answer',
  DECLINE: 'decline',
};

export const isRATAvailable = () =>
  typeof window !== 'undefined' &&
  window.RAT &&
  typeof window.RAT.addCustomEvent === 'function';

export const getRatAccountId = (): ?string => {
  const input = document.getElementById('ratAccountId');
  if (input && input instanceof HTMLInputElement && input.value) {
    return input.value;
  }
  return null;
};

// export const getScreenNameByToastState = (toastState: string): ?string => {
//   // let screen;
//   // if (permissionState === TOAST_STATE_ASK) {
//   //   screen = SCREEN.TOAST;
//   // } else if (permissionState === TOAST_STATE_NPS) {
//   //   screen = SCREEN.NPS;
//   // } else if (permissionState === TOAST_STATE_FORM) {
//   //   screen = SCREEN.FORM;
//   // } else if (permissionState === TOAST_STATE_FORM_AGREE) {
//   //   screen = SCREEN.FORM_AGREE;
//   // } else if (permissionState === TOAST_STATE_FORM_DISAGREE) {
//   //   screen = SCREEN.FORM_DISAGREE;
//   // } else if (permissionState === TOAST_STATE_DECLINED) {
//   //   screen = SCREEN.THANKYOU;
//   // } else if (permissionState === TOAST_STATE_COMPLETED) {
//   //   screen = SCREEN.THANKYOU;
//   // }
//   // return screen;
//
//   switch (toastState) {
//     case TOAST_STATE_ASK: {
//       return SCREEN.TOAST;
//     }
//     case TOAST_STATE_NPS: {
//       return SCREEN.NPS;
//     }
//     case TOAST_STATE_FORM: {
//       return SCREEN.FORM;
//     }
//     case TOAST_STATE_FORM_AGREE: {
//       return SCREEN.FORM_AGREE;
//     }
//     case TOAST_STATE_FORM_DISAGREE: {
//       return SCREEN.FORM_DISAGREE;
//     }
//     case TOAST_STATE_DECLINED: {
//       return SCREEN.THANKYOU;
//     }
//     case TOAST_STATE_COMPLETED: {
//       return SCREEN.THANKYOU;
//     }
//     default: {
//       return undefined;
//     }
//   }
// };

export const sendFreeAnswersToRAT = ({
  cId,
  npsValue,
  formInputValue = '',
}: {
  cId: string,
  npsValue: string,
  formInputValue: string,
}) => {
  if (isRATAvailable()) {
    const ratConfig = {
      accountId: RAT_ACCOUNT_ID_FOR_REX,
      serviceId: 1,
      includeInput: true,
      pData: {
        compid: ['answer_transmission'],
      },
      cpData: {
        campaign_acc: getRatAccountId(),
        campaign_id: cId,
        campaign_solution: 'in_page_survey',
        campaign_answer_nps: npsValue,
        campaign_answer_fa: encodeURIComponent(formInputValue),
      },
      options: ['url', 'ua'],
      eventType: 'async',
    };

    try {
      RAT.addCustomEvent(ratConfig);
    } catch (e) {
      console.error(e);
    }
    return true;
  }
  return false;
};

/**
 * sendRAT
 */
const sendRAT = ({
  cId,
  screen,
  action,
}: {
  cId: string,
  screen: string,
  action: string,
}) => {
  if (isRATAvailable()) {
    const ratConfig = {
      accountId: RAT_ACCOUNT_ID_FOR_REX,
      serviceId: 1,
      includeInput: true,
      pData: {
        compid: [`${screen}`, `${action}`],
      },
      cpData: {
        campaign_acc: getRatAccountId(),
        campaign_id: cId,
        campaign_solution: 'in_page_survey',
      },
      options: ['url', 'ua'],
      eventType: 'async',
    };

    try {
      RAT.addCustomEvent(ratConfig);
    } catch (e) {
      console.error(e);
    }
    return true;
  }
  return false;
};

export default sendRAT;



// WEBPACK FOOTER //
// ./src/phase2/survey/app/rat/index.js